/* eslint-disable react/prop-types */
import { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Layout from '../Components/Core/Layout';
import SEO from '../Components/Core/Seo';
import Hero from '../Components/Screens/Hero';
import Loader from '../Components/Core/Loader';

const NotFoundPage = ({
  location,
  data: {
    contentfulPageLayout: {
      languageToggle,
      topNotificationBanner,
      promoCode,
      customHeader,
      sections,
      customFooter,
      internal: { type },
    },
  },
}) => {
  // Set hero content/page title to null to avoid flashing of content until location.href has been detected
  const [heroData, setHeroData] = useState(null);

  // Check if there is an instance of "campaign" in the url, if so set page to campaign content otherwise display statndard content
  useLayoutEffect(() => {
    if (location.href.indexOf('campaign') > -1) {
      setHeroData(sections[1]);
    } else {
      setHeroData(sections[0]);
    }
  }, []);

  return (
    <Layout
      location={location}
      header={customHeader}
      footer={customFooter}
      languageToggle={languageToggle}
      promoCode={promoCode}
      banner={topNotificationBanner}
      contentType={type}
    >
      {heroData === null ? <Loader /> : <Hero data={heroData} />}
    </Layout>
  );
};

NotFoundPage.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
};

export const query = graphql`
  query NotFoundPage($locale: String = "en-CA") {
    contentfulPageLayout(
      contentful_id: { eq: "43jhL6Z7wxQOCbUKzBaVrI" }
      node_locale: { eq: $locale }
    ) {
      node_locale
      pageTitle
      metaDescription
      languageToggle
      displayInSiteMap
      promoCode
      internal {
        type
      }
      ...notification_banners
      ...global_header
      sections {
        ...hero_banner
      }
      ...global_footer
    }
  }
`;

export default NotFoundPage;

export const Head = ({ location, data, pageContext }) => {
  // Campaign page title
  const campaignPageTitle =
    pageContext.language === 'en' ? 'Offer Expired' : 'Offre Expirée';
  const fourOhFourPageTitle =
    pageContext.language === 'en' ? '404 | PC Financial' : '404 | PC Finance';
  const title =
    location.pathname.indexOf('campaign') > -1
      ? campaignPageTitle
      : fourOhFourPageTitle;

  return (
    <SEO
      title={title}
      data={data.contentfulPageLayout}
      pageContext={pageContext}
      location={location}
    />
  );
};
